import React from 'react';
import { Reveal, RevealLines } from './Reveal';
import { IMG } from '../data/site';

export default function About() {
  return (
    <section id="about" className="relative py-32 md:py-48 px-6 md:px-10 max-w-[1600px] mx-auto" data-testid="about-section">
      <div className="grid grid-cols-12 gap-6 md:gap-10">
        <Reveal className="col-span-12 md:col-span-3">
          <div className="flex md:flex-col items-baseline md:items-start gap-4">
            <span className="font-mono text-gold text-sm tracking-[0.3em]">01 —</span>
            <span className="overline">La Maison</span>
          </div>
        </Reveal>

        <div className="col-span-12 md:col-span-9">
          <h2 className="font-serif leading-[0.95] tracking-tight" style={{ fontSize: 'clamp(2.5rem, 6vw, 6rem)' }}>
            <RevealLines
              lines={[
                'Derrière Ô Fil des Verres,',
                <span key="i" className="italic text-char/50">il y a moi.</span>,
              ]}
              stagger={0.1}
            />
          </h2>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start">
            <Reveal className="md:col-span-7 space-y-6 text-char/75 text-base md:text-lg font-light leading-relaxed" delay={0.2}>
              <p>
                Passionné par l'univers du bar et de l'événementiel depuis plus de <span className="text-gold">15 ans</span>, j'ai créé <span className="text-char font-normal">Ô Fil des Verres</span>, un service de <span className="text-char font-normal">bar à cocktails événementiel basé à Montpellier</span>, pour partager mon savoir-faire et créer des expériences uniques autour du cocktail.
              </p>
              <p>
                En tant que <span className="text-char font-normal">barman événementiel</span>, j'accompagne particuliers et professionnels dans l'organisation de leurs <span className="text-char font-normal">mariages, anniversaires, séminaires, soirées privées et événements d'entreprise</span>.
              </p>
              <p>
                De la création des cocktails à la mise en place du bar, en passant par le service et l'animation, chaque détail est pensé pour offrir à vos invités une expérience conviviale, élégante et personnalisée.
              </p>
              <p>
                Basé à <span className="text-char font-normal">Montpellier</span>, j'interviens dans tout le <span className="text-char font-normal">Sud de la France</span>, notamment en <span className="text-char font-normal">Occitanie</span>, pour vos événements privés et professionnels. Que vous organisiez un mariage, un anniversaire ou un événement d'entreprise, <span className="text-char font-normal">Ô Fil des Verres</span> apporte son savoir-faire, son énergie et sa passion directement sur votre lieu de réception.
              </p>
              <p className="font-serif text-xl md:text-2xl text-char italic">
                Ô Fil des Verres, c'est plus qu'un bar à cocktails : c'est une expérience événementielle pensée pour créer des souvenirs.
              </p>
              <div className="pt-8 flex flex-wrap gap-8">
                <div>
                  <div className="font-serif text-4xl text-gold">15+</div>
                  <div className="overline mt-1">années</div>
                </div>
                <div>
                  <div className="font-serif text-4xl text-gold">100%</div>
                  <div className="overline mt-1">à la minute</div>
                </div>
                <div>
                  <div className="font-serif text-4xl text-gold">30+</div>
                  <div className="overline mt-1">cocktails signature</div>
                </div>
              </div>
            </Reveal>

            <Reveal className="md:col-span-5" delay={0.3}>
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={IMG.signature}
                  alt="Cocktail signature — création Ô Fil des Verres"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-char/10" />
                <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
                  <span className="overline text-white/90">Cocktail signature — Ô Fil des Verres</span>
                  <span className="font-mono text-gold text-xs">N° 07</span>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
